import { useState } from 'react';
import { LegalDocViewer } from './LegalDocViewer';

export function ConsentCheckbox({ document, checked, onChange }) {
  const [showDoc, setShowDoc] = useState(false);

  return (
    <>
      <label className="flex items-start gap-2.5 cursor-pointer text-sm">
        <input
          type="checkbox"
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
        />
        <span className="text-slate-700 leading-relaxed">
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); setShowDoc(true); }}
            className="text-blue-600 hover:underline font-medium"
          >
            {document.title}
          </button>
          {' '}belgesini okudum, kabul ediyorum.
        </span>
      </label>
      <LegalDocViewer
        open={showDoc}
        onClose={() => setShowDoc(false)}
        slug={document.slug}
        title={document.title}
      />
    </>
  );
}
